import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.424 3.776a.6.6 0 0 0-.848.848l11.5 11.5a.6.6 0 1 0 .848-.848l-11.5-11.5ZM2.323 8.99a10.655 10.655 0 0 1 1.834-2.37l2.119 2.118a4 4 0 0 0 5.186 5.186l1.664 1.664A8.09 8.09 0 0 1 10 16.2c-4.114 0-6.586-2.869-7.677-4.789a2.431 2.431 0 0 1 0-2.422Z",
      fill: "#333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.5 10.2c0-.076.003-.152.01-.227l2.717 2.717A2.5 2.5 0 0 1 7.5 10.2ZM15.843 13.78l-2.118-2.118a4 4 0 0 0-5.186-5.186L6.873 4.812A8.089 8.089 0 0 1 10 4.2c4.114 0 6.586 2.87 7.677 4.79a2.43 2.43 0 0 1 0 2.421 10.652 10.652 0 0 1-1.834 2.369Z",
      fill: "#333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.49 10.427 9.773 7.71a2.5 2.5 0 0 1 2.717 2.717Z",
      fill: "#333"
    }, null, -1)
  ])))
}
export default { render: render }